import { request } from "./http";

export interface SurveillanceAlert {
  id: string;
  user_id: string;
  user_email: string | null;
  user_name: string | null;
  detector_id: string;
  severity: "low" | "medium" | "high" | "critical";
  status: "open" | "reviewing" | "cleared" | "escalated";
  window_start: string;
  window_end: string;
  evidence_order_ids: string[];
  evidence_fill_ids: string[];
  payload: Record<string, unknown>;
  decision_note: string | null;
  decided_by: string | null;
  decided_at: string | null;
  created_at: string;
}

export interface RestrictedUser {
  id: string;
  user_id: string;
  user_email: string | null;
  category: "employee" | "pep" | "board_related" | "other" | string;
  note: string | null;
  added_at: string;
  removed_at: string | null;
}

export const surveillance = {
  list: (
    params: {
      status?: SurveillanceAlert["status"];
      detector?: string;
      limit?: number;
    } = {},
  ) => {
    const qs = new URLSearchParams();
    if (params.status) qs.set("status", params.status);
    if (params.detector) qs.set("detector", params.detector);
    if (params.limit) qs.set("limit", String(params.limit));
    return request<SurveillanceAlert[]>(
      `/api/v1/admin/surveillance/alerts${qs.toString() ? "?" + qs : ""}`,
    );
  },
  decide: (id: string, body: { status: SurveillanceAlert["status"]; note?: string }) =>
    request<SurveillanceAlert>(`/api/v1/admin/surveillance/alerts/${id}/decide`, {
      method: "POST",
      body,
    }),
  restrictedList: () =>
    request<RestrictedUser[]>("/api/v1/admin/surveillance/restricted-users"),
  restrictedAdd: (body: { user_id: string; category: RestrictedUser["category"]; note?: string }) =>
    request<RestrictedUser>("/api/v1/admin/surveillance/restricted-users", { body }),
  restrictedRemove: (id: string) =>
    request<{ id: string; status: string }>(
      `/api/v1/admin/surveillance/restricted-users/${id}`,
      { method: "DELETE" },
    ),
};
